var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container wechat-open-platform" },
    [
      _c("el-alert", {
        staticClass: "page-alert",
        attrs: {
          title:
            "服务商已接入授权、模板、发布前配置、体验版、代码审核与正式发布链路。",
          type: "info",
          closable: false,
          "show-icon": "",
        },
      }),
      _vm._v(" "),
      _c(
        "el-card",
        { attrs: { shadow: "never" } },
        [
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "小程序授权", name: "authorization" } },
                [
                  _vm.activeTab === "authorization"
                    ? _c("app-authorization")
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "服务商配置", name: "config" } },
                [_vm.activeTab === "config" ? _c("platform-config") : _vm._e()],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "模板管理", name: "template" } },
                [
                  _vm.activeTab === "template"
                    ? _c("template-management")
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "发布前配置", name: "preparation" } },
                [
                  _vm.activeTab === "preparation"
                    ? _c("release-preparation")
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "回调日志", name: "logs" } },
                [_vm.activeTab === "logs" ? _c("callback-logs") : _vm._e()],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }